import { render, staticRenderFns } from "./RecoveryFee.vue?vue&type=template&id=113b10a8&scoped=true&"
import script from "./RecoveryFee.vue?vue&type=script&lang=js&"
export * from "./RecoveryFee.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryFee.vue?vue&type=style&index=0&id=113b10a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b10a8",
  null
  
)

export default component.exports